<div class="app">
  <app-header />
  <main class="app__main">
    <router-outlet />
  </main>
  <app-footer />

  <app-cookies />
</div>
